<div class="list-tasks">
  <app-list-chips-active-filters [component]="filters" />

  <div *ngIf="isMyWork">
    <div class="list-tasks-main-group-wrapper">
      <div class="main-group-header">
        <h4 class="list-tasks-main-group-header">{{ 'Projects.projectTasks' | translate }}</h4>
        <app-button
          *ngIf="!(isDelegatedTasksTab$ | async)"
          class="mr-2 my-1 my-lg-0"
          (onClick)="createNewTaskGroup('project')"
          [permission]="{ group: PermissionsGroups.PROJECTS, action: 'EDIT' }"
          [config]="{
            size: ButtonSize.SMALL,
            type: ButtonTypes.NEW_SECONDARY_BLUE,
            text: ('Projects.newGroup' | translate),
            prependSrc: './assets/img/ic-plus.svg'
          }"
        />
      </div>

      @if (loading()) {
        <div class="d-flex align-items-center justify-content-center my-5">
          <div class="lds-dual-ring"></div>
        </div>
      }

      <div
        class="list-tasks-dynamic-container"
        #projectTasksDropzone
        (dndDrop)="dropEvent($event, 'project')"
        [dndDropzone]="['group']"
      >
        <div dndPlaceholderRef class="list-tasks-group--placeholder"></div>
        <ng-template #projectTasksContainer></ng-template>
      </div>
    </div>

    <div class="list-tasks-main-group-wrapper mt-3 mb-4">
      <div class="main-group-header">
        <h4 class="list-tasks-main-group-header">{{ 'Projects.withoutProjectTasks' | translate }}</h4>
        <app-button
          *ngIf="!(isDelegatedTasksTab$ | async)"
          class="mr-2 my-1 my-lg-0"
          (onClick)="createNewTaskGroup('without_project')"
          [permission]="{ group: PermissionsGroups.PROJECTS, action: 'EDIT' }"
          [config]="{
            size: ButtonSize.SMALL,
            type: ButtonTypes.NEW_SECONDARY_BLUE,
            text: ('Projects.newGroup' | translate),
            prependSrc: './assets/img/ic-plus.svg'
          }"
        />
      </div>

      @if (loading()) {
        <div class="d-flex align-items-center justify-content-center my-5">
          <div class="lds-dual-ring"></div>
        </div>
      }

      <div
        class="list-tasks-dynamic-container"
        #withoutProjectTasksDropzone
        (dndDrop)="dropEvent($event, 'without_project')"
        [dndDropzone]="['group']"
      >
        <div dndPlaceholderRef class="list-tasks-group--placeholder"></div>
        <ng-template #withoutProjectTasksContainer></ng-template>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isMyWork"
    class="list-tasks-dynamic-container"
    #dropzone
    (dndDrop)="dropEvent($event)"
    [dndDropzone]="['group']"
  >
    @if (loading()) {
      <div class="d-flex align-items-center justify-content-center my-5">
        <div class="lds-dual-ring"></div>
      </div>
    }
    <div dndPlaceholderRef class="list-tasks-group--placeholder"></div>
    <ng-template #container></ng-template>
  </div>
</div>
